import classNames from "classnames";
import React from "react";

import { ignoreAttribute } from "@ascendnow/shared";

import styles from "./AscCrosswordPuzzleCell.module.scss";

export interface AscCrosswordPuzzleCellProps {
  className?: string;
  character?: string;
  readonly?: boolean;
  empty?: boolean;
  error?: boolean;
  highlighted?: boolean;
  selected?: boolean;
  wordIndex?: number;
  id: number;
  onSelect?: (id: number) => void;
  onInput?: (id: number, character: string) => void;
  onNavigate?: (direction: string) => void;
}

const AscCrosswordPuzzleCell = React.forwardRef<
  HTMLInputElement,
  AscCrosswordPuzzleCellProps
>(
  (
    {
      className,
      character,
      readonly,
      empty,
      error,
      onSelect,
      onInput,
      onNavigate,
      wordIndex,
      highlighted,
      selected,
      id,
    },
    ref
  ) => {
    function handleOnClick() {
      if (empty || readonly) {
        return;
      }
      onSelect?.(id);
    }
    function handleInput(e: React.KeyboardEvent<HTMLInputElement>) {
      if (empty || readonly) {
        return;
      }
      const key = e?.key;
      if (
        key === "ArrowUp" ||
        key === "ArrowDown" ||
        key === "ArrowLeft" ||
        key === "ArrowRight"
      ) {
        onNavigate?.(key);
        return;
      }
      if (key.match(/[A-Z ]/i)?.[0] === key) {
        onInput?.(id, e?.key);
        return;
      }
    }
    return (
      <div
        data-testid={`asc-crossword-puzzle-cell-${id}`}
        className={classNames(
          styles.ground,
          {
            [styles.empty]: empty,
            [styles.highlighted]: highlighted,
            [styles.selected]: selected,
            [styles.error]: error,
          },
          className
        )}
        onClick={handleOnClick}
        {...ignoreAttribute.contrast}
      >
        <input
          ref={ref}
          className={styles.input}
          onKeyUp={handleInput}
          {...ignoreAttribute.contrast}
        />
        <span className={styles.wordIndex} {...ignoreAttribute.contrast}>
          {wordIndex}
        </span>
        <span className={styles.character} {...ignoreAttribute.contrast}>
          {" "}
          {character}
        </span>
      </div>
    );
  }
);

export default AscCrosswordPuzzleCell;
